import { ComponentProps } from "react";

import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: breadcrumb and see-all chevrons; the path lives in `IconSprite`. */
export const IconNavigationChevronRight = (props: ComponentProps<"svg">) => (
  <SpriteIcon
    symbol={SPRITE_SYMBOLS.navChevronRight}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  />
);
